import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface Review {
  id: string;
  title: string;
  rating: number;
  date: string;
  vehicle: string;
  comment: string;
}

/**
 * Displays a list of customer reviews and renders star ratings for each review.
 * @component
 * @selector app-reviews
 * @example
 *   <app-reviews></app-reviews>
 *
 * Purpose:
 *   Renders a collection of Review items (title, rating, date, vehicle, comment). The component uses an internal static reviews array for demo/display purposes and provides a helper method to convert numeric ratings into a boolean array used to render filled/unfilled stars in the template.
 *
 * @input none - This component does not declare any @Input properties. Reviews are currently maintained internally; to supply reviews from a parent component, add an @Input() reviews: Review[].
 * @output none - This component does not emit any @Output events. To notify a parent of user interactions (e.g., selecting or liking a review), add an @Output() EventEmitter as needed.
 *
 * Key methods:
 *   - getStarArray(rating: number): boolean[] - Returns an array of five booleans where indices less than the rating are true. Intended to drive visual star rendering in the template.
 *
 * Lifecycle hooks:
 *   - ngOnInit(): void - Implemented from OnInit. Currently contains no initialization logic but is present for future setup and initialization tasks.
 */
@Component({
  selector: 'app-reviews',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './reviews.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./reviews.component.scss'],
})
export class ReviewsComponent {
  reviews: Review[] = [
    {
      id: '1',
      title: 'Quick, Efficient, and Super Clean!',
      rating: 5,
      date: '15 March, 2025',
      vehicle: '2022 Porsche 911 GT3 RS',
      comment:
        'Booked an appointment online and was in and out in under 30 minutes. The exterior wash was spotless, and they even cleaned the rims really well. Great value for the price!',
    },
    {
      id: '2',
      title: 'Great Service and Attention to Detail!',
      rating: 5,
      date: '26 August, 2024',
      vehicle: '2023 BMW M5 Competition',
      comment:
        'I took my car in for a full wash and interior detailing, the team did an amazing job. The staff was friendly, the wait time was short, and my car looked brand new when they were done. Will definitely be comin... more',
    },
  ];

  constructor() {}

  getStarArray(rating: number): boolean[] {
    return Array(5)
      .fill(false)
      .map((_, index) => index < rating);
  }

  trackByIndex(index: number): number {
    return index;
  }
  trackByValue(_: number, item: any): any {
    return item?.value ?? item;
  }
  trackById(_: number, item: any): any {
    return item?.id ?? item;
  }
  trackByString(_: number, s: any): any {
    return s;
  }
}
